// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GvV7BDSHKEqPaQ {\n  background: var(--ds-background-accent-gray-subtlest, #EBECF0);\n}\n.xJM_gd_GpGM0yl {\n  margin-right: 8px;\n}\n.xJM_gd_GpGM0yl:visited,\n.xJM_gd_GpGM0yl:active {\n  outline: none;\n}\n.xJM_gd_GpGM0yl:focus {\n  outline: -webkit-focus-ring-color auto 1px;\n}\n.xJM_gd_GpGM0yl .icon-template-card {\n  margin-right: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": "GvV7BDSHKEqPaQ",
	"cardTemplateButton": "xJM_gd_GpGM0yl"
};
export default ___CSS_LOADER_EXPORT___;
